import clsx from 'clsx';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { KeyValueRows } from './KeyValueRows';
import styles from './modalMetricCreate.module.scss';
import { MetricFormData } from './schemas';

type Props = {
  disabled?: boolean;
};

/** API Classifier configuration fields (URL, headers, async toggle). */
export const MetricApiConfigFields: React.FC<Props> = ( { disabled } ) => {
  const { register, formState: { errors } } = useFormContext<MetricFormData>();
  const configErrors = errors.config as { url?: { message?: string } } | undefined;

  return (
    <>
      <div className={ clsx( 'layout__col', 'pad' ) }>
        <label className={ clsx( 'auth_flow_label', configErrors?.url && 'required' ) } htmlFor="config.url">
          API URL <span className={ styles.required_asterisk }>*</span>
        </label>
        <textarea
          id="config.url"
          className={ styles.url_textarea }
          rows={ 3 }
          disabled={ disabled }
          placeholder="https://..."
          data-testid="api-url-input"
          { ...register( 'config.url' ) }
        />
        {configErrors?.url && <div className={ styles.error_message }>{configErrors.url.message}</div>}
      </div>

      <div className={ clsx( 'layout__col', 'pad' ) }>
        <label className="auth_flow_label">API Headers</label>
        <KeyValueRows
          name="config.headers"
          keyField="header"
          valueField="value"
          keyLabel="Name"
          valueLabel="Value"
          addLabel="Add header"
          testIdPrefix="api-header"
          disabled={ disabled }
        />
      </div>

      <div className={ clsx( 'layout__row', 'pad', 'flex_left', styles.async_row ) }>
        <label className="auth_flow_label" htmlFor="config.isAsync">Is metric async?</label>
        <input
          id="config.isAsync"
          type="checkbox"
          disabled={ disabled }
          data-testid="async-checkbox"
          { ...register( 'config.isAsync' ) }
        />
      </div>
    </>
  );
};
